/* eslint no-unused-vars:0 */
import pageContext from '@bingads-webui-static-legacy/page-context';
import ko from 'knockout';
import Backbone from 'backbone';
import _ from '@bingads-webui-component-legacy/extension/underscore';
import template from '@bingads-webui-campaign-legacy/advanced-settings/template/base-exclusion.pug';
import BaseExclusionViewModel from '@bingads-webui-campaign-legacy/advanced-settings/viewmodel/base-exclusion';
import config from '@bingads-webui-component-legacy/config/index';
import state from '@bingads-webui-component-legacy/state/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const entitySeparator = '-------------------------';
const exclusionType2String = {
  site: {
    instruction: 'CampaignCreate_WebSiteExclusions_Instruction',
    label: 'Entity_Sites',
    numberExcluded: 'AdvancedSetting_EditWebSiteExclusionDesc',
  },
  ip: {
    instruction: 'CampaignCreate_IPExclusions_Instruction',
    label: 'Entity_IPs',
    numberExcluded: 'AdvancedSetting_EditIPExclusionDesc',
  },
};

export default class View extends Backbone.View {
  initialize({
    exclusionType = 'site',
    exclusions = '',
    campaignExclusions = '',
    level = 'campaign',
  } = {}) {
    this.viewModel = new BaseExclusionViewModel({
      exclusionType,
      exclusions,
      exclusionType2String,
      entitySeparator,
      campaignExclusions,
    });

    this.exclusionType = exclusionType;
    this.level = level;
    this.isNewUI = config.get('IsNewUI');
    this.isInSiteExclusionListPilot = pageContext.Permissions.IsManagerAccountSharedWebsiteExclusionsEnabled;
  }

  get events() {
    return {
      'show.bs.collapse': 'showSettings',
      'hide.bs.collapse': 'hideSettings',
    };
  }

  showSettings() {
    this.viewModel.isExpanded(true);
  }

  hideSettings() {
    this.viewModel.isExpanded(false);
  }

  render() {
    let siteExclusionListHref = '';

    if (this.isNewUI && this.isInSiteExclusionListPilot && this.exclusionType === 'site') {
      const queryString = `?uid=${state.get('user_id')}&cid=${state.get('customer_id')}&aid=${state.get('account_id')}`;

      siteExclusionListHref = `/campaign/vnext/siteexclusionlists/viewlists${queryString}`;
    }

    this.$el.html(template({
      i18n,
      instruction: i18n.get(exclusionType2String[this.exclusionType].instruction),
      exclusionType: this.exclusionType,
      labelText: i18n.get(exclusionType2String[this.exclusionType].label),
      isAdGroupLevel: this.level === 'adgroup',
      isNewUI: this.isNewUI,
      isInSiteExclusionListPilot: this.isInSiteExclusionListPilot,
      siteExclusionListHref,
    }));
    ko.applyBindings(this.viewModel, this.el);

    return this;
  }

  getValues() {
    let exclusions = this.viewModel.exclusions() || '';

    return exclusions.replace(entitySeparator, '');
  }

  clearApiErrors() {
    this.viewModel.errors([]);
  }

  showErrors(errors) {
    if (!errors) {
      return;
    }
    this.$(`#${this.exclusionType}ExclusionSettings`).collapse('show');

    if (_.isArray(errors.InvalidEntities) && !_.isEmpty(errors.InvalidEntities)) {
      let entities = errors.InvalidEntities;

      if (_.isArray(errors.ValidEntities) && !_.isEmpty(errors.ValidEntities)) {
        entities.push(entitySeparator);
        entities = _.union(entities, errors.ValidEntities);
      }

      this.viewModel.exclusions(entities.join('\r\n'));
    }

    if (_.isArray(errors.EntityErrors) && !_.isEmpty(errors.EntityErrors)) {
      this.viewModel.errors(errors.EntityErrors);
    }
  }
}
